/**
 * Vendor Bot Admin - Analytics Page
 * Sales charts, conversion rates, metrics
 */

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/Layout';
import Navbar from '../../components/Navbar';
import StatsCard from '../../components/StatsCard';
import Chart from '../../components/Chart';
import { useTelegram } from '../../hooks/useTelegram';

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
`;

const PeriodSelector = styled.div`
  display: flex;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-lg);
  background: var(--bg-card);
  padding: var(--spacing-sm);
  border-radius: var(--radius-md);
`;

const PeriodButton = styled.button<{ active: boolean }>`
  flex: 1;
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-md);
  font-size: var(--font-sm);
  font-weight: var(--font-medium);
  background: ${({ active }) => (active ? 'var(--accent-green)' : 'transparent')};
  color: ${({ active }) => (active ? 'white' : 'var(--text-secondary)')};
`;

const AdminAnalytics: React.FC = () => {
  const { botUsername } = useParams<{ botUsername: string }>();
  const navigate = useNavigate();
  const { showBackButton } = useTelegram();
  const [period, setPeriod] = useState<'7d' | '30d' | '90d'>('30d');

  useEffect(() => {
    showBackButton(() => navigate(`/vendor/${botUsername}/admin/dashboard`));
  }, [showBackButton, navigate, botUsername]);

  return (
    <Layout header={<Navbar title="Analytics" subtitle="Sales Performance" showBack />}>
      <PeriodSelector>
        <PeriodButton active={period === '7d'} onClick={() => setPeriod('7d')}>
          7 Days
        </PeriodButton>
        <PeriodButton active={period === '30d'} onClick={() => setPeriod('30d')}>
          30 Days
        </PeriodButton>
        <PeriodButton active={period === '90d'} onClick={() => setPeriod('90d')}>
          90 Days
        </PeriodButton>
      </PeriodSelector>

      <StatsGrid>
        <StatsCard
          label="Revenue"
          value="$1,234"
          icon="💰"
          color="var(--accent-green)"
          change={{ value: '12%', positive: true }}
        />
        <StatsCard label="Orders" value="45" icon="📦" change={{ value: '8%', positive: true }} />
        <StatsCard label="Customers" value="127" icon="👥" change={{ value: '15%', positive: true }} />
        <StatsCard label="Conversion" value="3.2%" icon="📈" change={{ value: '0.5%', positive: true }} />
      </StatsGrid>

      <Chart title="Revenue Trend" type="line" height={200} />
      <Chart title="Top Products" type="bar" height={200} />
      <Chart title="Sales by Category" type="pie" height={200} />
    </Layout>
  );
};

export default AdminAnalytics;
